import { RootState } from ".";
import { initialState as appState } from './appSlice';
import { cloneDeep, merge } from "lodash";

const stateKey = 'state';

const getSavedState = (state: RootState): Partial<RootState> =>{
  return {
    app: cloneDeep(state.app)
  }
}

export const loadState = (): Partial<RootState> => {
  let initialRootState: Partial<RootState> = {
    app: cloneDeep(appState),
  };
  try {
    const serializedState = localStorage.getItem(stateKey);
    if (serializedState === null) {
      return initialRootState;
    }
    const loadedState = JSON.parse(serializedState);
    initialRootState = merge(initialRootState, loadedState);
    console.log('loaded initial state', initialRootState);
    return initialRootState;
  } catch (err) {
    console.log(err);
    return initialRootState;
  }
};

export const saveState = (state: RootState) => {
  console.log("saving local state");
  try {
      const savedState = getSavedState(state);
      const serializedState = JSON.stringify(savedState);
      localStorage.setItem(stateKey, serializedState);
    } catch {
    // ignore write errors
  }
};

export const removePersistedState = () => {
  try {
    localStorage.removeItem(stateKey);
  } catch (error) {
    console.error(error);
  }
}